module.exports = __webpack_public_path__ + "img/swiper_3.5_3_3.11a35cfb.webp";